var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
      'text-center day-item': true,
      'is-today': _vm.day.isToday,
      'is-disabled': !_vm.day.isPast,
      'is-selected': _vm.day.isSelected
    },on:{"click":_vm.selectDate}},[_c('input',{attrs:{"disabled":_vm.day.isPast,"type":"checkbox","hidden":"","id":`day${_vm.day.isoDate}`}}),_c('label',{class:{ 'my-2 mx-0 flex-column': true },attrs:{"title":_vm.showTitle(),"for":`day${_vm.day.isoDate}`}},[_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.day.isoDate,'dd')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }